module.exports = __webpack_public_path__ + "img/new7.b4af1e03.png";